import JSONApiClient from '../jsonapi-service';
import { authService } from '../auth-service';
import AxiosService from '../axios-service';

export function createTrackedAsset(data) {
  const client = JSONApiClient();

  const trackedAsset = client.create('trackedAssets');

  trackedAsset.set('assetId', data.assetId);
  trackedAsset.set('assetURL', data.assetURL);
  trackedAsset.set('user', { type: 'users', id: data.userId });
  trackedAsset.set('platform', data.platform);
  trackedAsset.set('assetType', data.assetType);
  if (data.discussionId) { trackedAsset.set('discussion', { type: 'discussions', id: data.discussionId }); }
  if (data.campaignId) { trackedAsset.set('campaign', { type: 'campaigns', id: data.campaignId }); }
  if (data.discussionName) { trackedAsset.set('discussionName', data.discussionName); }
  trackedAsset.set('createdSource', data.createdSource);

  return trackedAsset.sync()
    .then(response => response);
}

function makeGetTrackedAssetQuery(assetId) {
  const query = `
  query TrackedAssets {
    trackedAssets(assetId: "${assetId}") {
      id
      assetId
      assetURL
      createdSource
      createdDate
      discussionName
      platform
      campaign {
        id
        name
      }
      user {
        id
        name
      }
      discussion {
        id
        name
      }
    }
  }
  `;
  return query;
}

export function getTrackedAsset(assetId) {
  const axiosService = new AxiosService(process.env.REACT_APP_API_BASE_URL, 10000, { Authorization: `Bearer ${authService.getToken()}` });

  const query = makeGetTrackedAssetQuery(assetId);

  return axiosService.post('', {
    query,
    variables: null,
    operationName: null,
  })
    .then(response => response.data.data.trackedAssets);
}

function makeGetUserTrackedVideoListQuery(userId) {
  const query = `
  query TrackedAssets {
    trackedAssets(user: "${userId}", createdSource: "USER") {
      id
      assetId
      assetURL
      platform
      assetType
      createdSource
      campaign {
        id
        name
      }
      user {
        id
        name
      }
      discussion {
        id
        name
      }
    }
  }
  `;
  return query;
}

export function getTrackedAssetList(userId) {
  const axiosService = new AxiosService(process.env.REACT_APP_API_BASE_URL, 10000, { Authorization: `Bearer ${authService.getToken()}` });

  const query = makeGetUserTrackedVideoListQuery(userId);

  return axiosService.post('', {
    query,
    variables: null,
    operationName: null,
  })
    .then(response => response.data.data.trackedAssets);
}



/** WEBPACK FOOTER **
 ** ./src/utils/jsonapi-functions/tracked-assets.js
 **/